import { useCallback } from "react";
import { AppContext, AppDispatch } from "../../../context";
import { AppContextHookReturnType } from "../../../state";
import { useAppDispatch, useAppState } from "../../context/contextVars";
import { AppActionType } from "../../../actions";

export const useAppContext: () => AppContextHookReturnType = () => {
  const appState = useAppState(AppContext);
  const appDispatch = useAppDispatch(AppDispatch);

  const updateState = useCallback(
    (actionType: any) => (data: any) => {
      appDispatch({
        type: actionType,
        payload: data,
      });
    },
    [appDispatch],
  );

  const actionList = {
    updateContactFormDetails: updateState(
      AppActionType.UPDATE_CONTACT_FORM_DETAILS,
    ),
    setSelectedCity: updateState(AppActionType.SET_SELECTED_CITY),
  };

  return {
    appState,
    ...actionList,
  };
};
